import { render, staticRenderFns } from "./signBankProtocol.vue?vue&type=template&id=997876f6&scoped=true"
import script from "./signBankProtocol.vue?vue&type=script&lang=js"
export * from "./signBankProtocol.vue?vue&type=script&lang=js"
import style0 from "./signBankProtocol.vue?vue&type=style&index=0&id=997876f6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "997876f6",
  null
  
)

export default component.exports